type PlainObject = Record<string, unknown>;

export function deepMerge<T extends PlainObject>(
  target: T,
  ...sources: Array<Partial<T> | undefined | null>
): T {
  if (!sources.length) return target;

  const source = sources.shift();

  if (!source) {
    return deepMerge(target, ...sources);
  }

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      const sourceValue = source[key] as unknown;
      const targetValue = target[key] as unknown;

      if (Array.isArray(sourceValue) && Array.isArray(targetValue)) {
        (target as PlainObject)[key] = mergeArrays(targetValue, sourceValue);
      } else if (isObject(sourceValue) && isObject(targetValue)) {
        (target as PlainObject)[key] = deepMerge({ ...targetValue }, sourceValue);
      } else {
        (target as PlainObject)[key] = sourceValue;
      }
    }
  }

  return deepMerge(target, ...sources);
}

function mergeArrays(target: unknown[], source: unknown[]): unknown[] {
  const result = [...target];

  for (const [index, item] of source.entries()) {
    if (item === null || item === undefined) {
      continue;
    }

    if (isObject(item) && isObject(result[index])) {
      result[index] = deepMerge({ ...(result[index] as PlainObject) }, item);
    } else {
      result[index] = item;
    }
  }

  return result;
}

function isObject(item: unknown): item is PlainObject {
  return item !== null && typeof item === "object" && !Array.isArray(item);
}
